import {TestPanelCard as TestPanelCardImpl} from './component';
import {useTestPanelCardContext} from './context';

export const TestPanelCard = Object.assign(TestPanelCardImpl, {
	useContext: useTestPanelCardContext,
});
